import styled from "@emotion/styled";
import { Drawer, IconButton } from "@mui/material";

import { BasicFlex } from "../../utils/Common";

import useMessageDialog from "./index";

import useIsMobile from "../../hooks/useIsMobile";

import MessagesDisplay from "../../components/Messages/MessagesDisplay";

import CloseRounded from '@mui/icons-material/CloseRounded';
import MinimizeRounded from '@mui/icons-material/MinimizeRounded';
import KeyboardArrowUpRounded from '@mui/icons-material/KeyboardArrowUpRounded';

const CloseButtonStyles = styled(BasicFlex)`
  position: absolute;
  top: .5rem;
  right: 1rem;
  /* width: fit-content; */
  cursor: pointer;
  z-index: 5000;
`

const CloseButton = () => {
  const hideDialog = useMessageDialog((state) => state.hideDialog);
  const is_minimized = useMessageDialog((state) => state.is_minimized);

  const toggleMinimize = useMessageDialog((state) => state.toggleMinimize);
  return (
    <CloseButtonStyles justify="flex-end">
      <IconButton size="small" onClick={toggleMinimize}>
        {is_minimized ? <KeyboardArrowUpRounded /> : <MinimizeRounded />}
      </IconButton>
      <IconButton onClick={hideDialog} color="basic" size="small">
        <CloseRounded />
      </IconButton>
    </CloseButtonStyles>
  )
}

const MessageDialog = () => {
  const { isMobile } = useIsMobile();

  // store state
  const open = useMessageDialog((state) => state.open);
  const is_minimized = useMessageDialog((state) => state.is_minimized);
  const hideDialog = useMessageDialog((state) => state.hideDialog);
  const customer_id = useMessageDialog((state) => state.customer_id);
  const customer_name = useMessageDialog((state) => state.customer_name);
  const customer_phone = useMessageDialog((state) => state.customer_phone);
  const resource = useMessageDialog((state) => state.resource);
  const resource_id = useMessageDialog((state) => state.resource_id);

  return (
    <Drawer
      anchor="bottom" // 1. Moves the entry point to the bottom
      open={open}
      onClose={hideDialog}
      variant="temporary"
      hideBackdrop={true} // 2. Removes the dark background overlay
      disableEnforceFocus 
      disableAutoFocus
      sx={{ pointerEvents: "none", zIndex: (theme) => theme.zIndex.drawer }}
      slotProps={{
        root: {
          // This is crucial: it prevents the invisible backdrop from blocking clicks
          style: { pointerEvents: 'none' } 
        },
        paper: {
          sx: {
            pointerEvents: "auto", // Re-enables clicks for the drawer content itself
            height: is_minimized ? "50px" : "75vh", // 3. Sets height to 70% of viewport height
            transition: "height 0.3s ease-in-out",
            // p: ".5rem",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            width: isMobile ? "100%" : "40rem",
            left: "auto",   // 1. Removes the left-side pinning
            right: isMobile ? 0 : "2rem",       // 2. Pins it strictly to the right
            overflowX: "hidden",
            boxShadow: "0px -2px 10px rgba(0,0,0,0.1)" // Adds depth since backdrop is gone
          },
        },
      }}
    >
      <CloseButton />
      <MessagesDisplay includeHeader={true} customer_id={customer_id} customer_name={customer_name} customer_phone={customer_phone} resource={resource} resource_id={resource_id} dialog={true} />
    </Drawer>
  );
};

export default MessageDialog;